<script lang="ts" setup>
import { $fetch } from '@@home/plugins/fetch';
import TechnicalOversightCommiteeMentor from './TechnicalOversightCommiteeMentor.vue';
import InfoCard from '@@home/components/InfoCard.vue';
import PeopleCard from '@@home/components/PeopleCard.vue';
import NumberCard from './NumberCard.vue';
import { useAsyncData } from '@@home/hooks/async-data';

const { data: toc } = useAsyncData('about:toc', () => $fetch('/committee/member/v1/list', { data: { committeeType: 2 } }))
</script>

<template>
  <section class="page-about-technical-oversight-commitee bg-[rgba(45,45,45,0.02)] pt-48px">
    <div class="about-technical-oversight-commitee-container container">
      <h2 class="m-0 text-center text-32px font-medium">{{ $t('about.technicalOversightCommitee.title') }}</h2>

      <InfoCard :title="$t('about.technicalOversightCommitee.title')" class="structure-box mt-32px">
        <p class="m-0 text-16px leading-24px">{{ $t('about.technicalOversightCommitee.description') }}</p>
        <ul class="mx-0 mb-0 mt-16px flex flex-wrap list-none p-0">
          <li class="w-25%">
            <NumberCard number="1">{{ $t('about.technicalOversightCommitee.duty1') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="2">{{ $t('about.technicalOversightCommitee.duty2') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="3">{{ $t('about.technicalOversightCommitee.duty3') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="4">{{ $t('about.technicalOversightCommitee.duty4') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="5">{{ $t('about.technicalOversightCommitee.duty5') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="6">{{ $t('about.technicalOversightCommitee.duty6') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="7">{{ $t('about.technicalOversightCommitee.duty7') }}</NumberCard>
          </li>
        </ul>
      </InfoCard>

      <ul class="directors mx-0 mb-0 mt-48px flex flex-wrap list-none p-0">
        <li class="w-223px flex-shrink-0 <2xl:w-222px" v-for="item in toc" :key="item.id">
          <PeopleCard :name="item.name" :position="item.position" :photo="item.photo" :intro="item.intro" :resume="item.resume" />
        </li>
      </ul>
    </div>

    <TechnicalOversightCommiteeMentor />
  </section>
</template>

<style lang="scss" scoped>
.page-about-technical-oversight-commitee {
  .structure-box {
    ul {
      li {
        &:nth-child(n+5) {
          margin-top: 32px;
        }
      }
    }
  }

  .directors {
    li {
      + li {
        @apply ml-56px <2xl:ml-22px;
      }

      &:nth-child(5n + 1) {
        margin-left: 0;
      }

      &:nth-child(n + 6) {
        margin-top: 48px;
      }
    }
  }
}
</style>
